import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { DEFAULT_PERMISSION_DETAILS, PUBLIC } from '../../getCheckedOptionFromView';
import { jsx as _jsx } from "react/jsx-runtime";
export const PublicRadioOption = ({
  checkedOption,
  setCheckedOption,
  setViewUpdates
}) => {
  const isChecked = checkedOption === PUBLIC;
  const handleChange = useCallback(() => {
    setCheckedOption(PUBLIC);
    setViewUpdates({
      teamId: undefined,
      private: false,
      permissionDetails: DEFAULT_PERMISSION_DETAILS
    });
  }, [setCheckedOption, setViewUpdates]);
  return /*#__PURE__*/_jsx(RadioInput, {
    "data-test-id": `view-sharing-everyone-checked=${isChecked}`,
    checked: isChecked,
    onChange: handleChange,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.everyone"
    })
  });
};